import React, { useState, useEffect } from "react";
import { getAxiosResponse, postAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { Link } from "react-router-dom";
import $ from "jquery";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";


export default function Notification(prop) {

  const { t } = useTranslation();
  const translate = t;
  const owner = useSelector(
    (reduxStore) => reduxStore.loginSession
  ).value;
  const userDetail = prop.user.resource
  const userEmail = userDetail.email
  const userId = userDetail.userId
  const [disabled, setdisabled] = useState(true);
  const [notChanged, setChange] = useState(false)
  const [notificatonPreference, setNotificatonPreference] = useState({})
  const [disableEditButton, setDisableEditButton] = useState(false);
  const [showEditButton, setShowEditButton] = useState(true);


  const unabledCheck = () => {
    setdisabled(!disabled);
    setShowEditButton(false);
  };

  const updateNotificationPreference = (e, key, value) => {
    var copy = []
    copy = Object.assign({}, notificatonPreference);
    copy[key] = value
    setNotificatonPreference([])
    setNotificatonPreference(copy)
    notChanged ? setChange(false) : setChange(true)
  }

  const updateNotification = () => {
    postAxiosResponse(APIUrls.USER_NOTIFICATION_PREFERENCES(userId), notificatonPreference).then((res) => {
      getData()
      setdisabled(true)
      setShowEditButton(true)
    })
    $('button.active').trigger('focus');
  }

  const onCancel = () => {
    getData();
    setdisabled(true);
    setShowEditButton(true);
    setTimeout(() => {
      $('#edit-btn').trigger('focus');
    }, 300);
  }
  const getData = () => {
    if (userId !== undefined) {
      getAxiosResponse(APIUrls.USER_NOTIFICATION_PREFERENCES(userId)).then((res) => {
        setNotificatonPreference(res.data.data);
      })
    }
  }
  useEffect(() => {
    setDisableEditButton(userId !== owner.id);
    getData()
  }, [userId])

  return (
    <>
      <div className={notChanged ? "inner-heading flex mar-bot25" : "inner-heading flex mar-bot25 noti"}>
        <div className="left">
          <h4>Notification Preferences</h4>
          <p>
{translate("my_account.email_notifications")}            <br />
         {translate("my_account.sent_to_notifications")} {userEmail}
            <Link onClick={prop.redirect} >Change</Link>
          </p>
        </div>
        <div className="flex two-col flex-center">
          {showEditButton && <button id="edit-btn" className="dashboard-btn" onClick={unabledCheck} disabled={disableEditButton}>
            Edit
          </button>}
        </div>
      </div>
      <div className="notifications-inner-tab show">
        <h5 className="heading-width-border" id="generalNotification">General Notifications</h5>
        <div className="general-notification-section">
          <div className="table-responsive global-table">
            <table className="sortable" aria-describedby="generalNotification">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  <th>Never</th>
                  <th>Always</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{translate("my_account.updates_user_profile")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_USER_PROFILE_UPDATE"
                        id="never"
                        disabled={disabled}
                        value={notificatonPreference?.NOTIFY_ON_USER_PROFILE_UPDATE === 'NONE'}
                        checked={notificatonPreference?.NOTIFY_ON_USER_PROFILE_UPDATE === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_USER_PROFILE_UPDATE', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="never"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_USER_PROFILE_UPDATE"
                        id="always"
                        value={notificatonPreference?.NOTIFY_ON_USER_PROFILE_UPDATE === 'ALL'}
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_USER_PROFILE_UPDATE === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_USER_PROFILE_UPDATE', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="always"
                      ></label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <h5 className="heading-width-border flex-center justify-center" id="generalProjectNotifications">
          General Project Notifications
        </h5>
        <div className="general-project-notification-section show">
          <div className="table-responsive global-table">
            <table className="sortable" aria-describedby="generalProjectNotifications">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  <th>Never</th>
                  <th>Projects I am following</th>
                  <th>All projects</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{translate("my_account.cancels_project")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_CANCEL"
                        id="rd1"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_CANCEL === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_CANCEL', 'NONE')}
                      />
                      <label className="form-check-label" htmlFor="rd1"></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_CANCEL"
                        id="rd2"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_CANCEL === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_CANCEL', 'DEFAULT')}
                      />
                      <label className="form-check-label" htmlFor="rd2"></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_CANCEL"
                        id="rd3"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_CANCEL === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_CANCEL', 'ALL')}
                      />
                      <label className="form-check-label" htmlFor="rd3"></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{translate("my_account.closed_project")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_CLOSED"
                        id="rd4"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_CLOSED === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_CLOSED', 'NONE')}
                      />
                      <label className="form-check-label" htmlFor="rd4"></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_CLOSED"
                        id="rd5"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_CLOSED === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_CLOSED', 'DEFAULT')}
                      />
                      <label className="form-check-label" htmlFor="rd5"></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_CLOSED"
                        id="rd6"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_CLOSED === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_CLOSED', 'ALL')}
                      />
                      <label className="form-check-label" htmlFor="rd6"></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{translate("my_account.alert_generation")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_ALERTS"
                        id="rd7"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_ALERTS === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_ALERTS', 'NONE')}
                      />
                      <label className="form-check-label" htmlFor="rd7"></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_ALERTS"
                        id="rd8"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_ALERTS === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_ALERTS', 'DEFAULT')}
                      />
                      <label className="form-check-label" htmlFor="rd8"></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_ALERTS"
                        id="rd9"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_ALERTS === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_ALERTS', 'ALL')}
                      />
                      <label className="form-check-label" htmlFor="rd9"></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
{translate("my_account.removes_follower")}                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_REMOVE_AS_PROJECT_FOLLOWER"
                        id="rd10"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_REMOVE_AS_PROJECT_FOLLOWER === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_REMOVE_AS_PROJECT_FOLLOWER', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd10"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_REMOVE_AS_PROJECT_FOLLOWER"
                        id="rd11"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_REMOVE_AS_PROJECT_FOLLOWER === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_REMOVE_AS_PROJECT_FOLLOWER', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd11"
                      ></label>
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    When someone creates a project and adds me as a follower
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_ADDED_AS_PROJECT_FOLLOWER"
                        id="rd1NOTIFY_ON_ADDED_AS_PROJECT_FOLLOWER"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_ADDED_AS_PROJECT_FOLLOWER === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_ADDED_AS_PROJECT_FOLLOWER', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd1NOTIFY_ON_ADDED_AS_PROJECT_FOLLOWER"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_ADDED_AS_PROJECT_FOLLOWER"
                        id="rd2NOTIFY_ON_ADDED_AS_PROJECT_FOLLOWER"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_ADDED_AS_PROJECT_FOLLOWER === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_ADDED_AS_PROJECT_FOLLOWER', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd2NOTIFY_ON_ADDED_AS_PROJECT_FOLLOWER"
                      ></label>
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    {translate("my_account.reopens_")}
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_REOPEN_LANGUAGE_EMAIL_PROJECT_OWNER"
                        id="rd1NOTIFY_ON_REOPEN_LANGUAGE_EMAIL_PROJECT_OWNER"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_REOPEN_LANGUAGE_EMAIL_PROJECT_OWNER === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_REOPEN_LANGUAGE_EMAIL_PROJECT_OWNER', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd1NOTIFY_ON_REOPEN_LANGUAGE_EMAIL_PROJECT_OWNER"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_REOPEN_LANGUAGE_EMAIL_PROJECT_OWNER"
                        id="rd15NOTIFY_ON_REOPEN_LANGUAGE_EMAIL_PROJECT_OWNER"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_REOPEN_LANGUAGE_EMAIL_PROJECT_OWNER === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_REOPEN_LANGUAGE_EMAIL_PROJECT_OWNER', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd15NOTIFY_ON_REOPEN_LANGUAGE_EMAIL_PROJECT_OWNER"
                      ></label>
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>
{translate("my_account.ownership_changes")}                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_OWNER_REASSIGNMENT"
                        id="rd13NOTIFY_ON_PROJECT_OWNER_REASSIGNMENT"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_OWNER_REASSIGNMENT === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_OWNER_REASSIGNMENT', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd13NOTIFY_ON_PROJECT_OWNER_REASSIGNMENT"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_OWNER_REASSIGNMENT"
                        id="rd15NOTIFY_ON_PROJECT_OWNER_REASSIGNMENT"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_OWNER_REASSIGNMENT === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_OWNER_REASSIGNMENT', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd15NOTIFY_ON_PROJECT_OWNER_REASSIGNMENT"
                      ></label>
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    {translate("my_account.encounters_error_delivery")}
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_SOURCE_ERROR"
                        id="rd13NOTIFY_ON_PROJECT_SOURCE_ERROR"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_SOURCE_ERROR === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_SOURCE_ERROR', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd13NOTIFY_ON_PROJECT_SOURCE_ERROR"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_SOURCE_ERROR"
                        id="rd15NOTIFY_ON_PROJECT_SOURCE_ERROR"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_SOURCE_ERROR === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_SOURCE_ERROR', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd15NOTIFY_ON_PROJECT_SOURCE_ERROR"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_SOURCE_ERROR"
                        id="rd153NOTIFY_ON_PROJECT_SOURCE_ERROR"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_SOURCE_ERROR === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_SOURCE_ERROR', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd153NOTIFY_ON_PROJECT_SOURCE_ERROR"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    {translate("my_account.encounters_error_delivery")}
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_TARGET_ERROR"
                        id="rd13NOTIFY_ON_PROJECT_TARGET_ERROR"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_TARGET_ERROR === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_TARGET_ERROR', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd13NOTIFY_ON_PROJECT_TARGET_ERROR"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_TARGET_ERROR"
                        id="rd15NOTIFY_ON_PROJECT_TARGET_ERROR"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_TARGET_ERROR === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_TARGET_ERROR', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd15NOTIFY_ON_PROJECT_TARGET_ERROR"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_TARGET_ERROR"
                        id="rd5NOTIFY_ON_PROJECT_TARGET_ERROR"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_TARGET_ERROR === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_TARGET_ERROR', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd5NOTIFY_ON_PROJECT_TARGET_ERROR"
                      ></label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <h5 className="heading-width-border flex-center justify-center" id="campaignNotifications">
          Campaign Notifications
        </h5>
        <div className="campaign-notification-section show">
          <div className="table-responsive global-table">
            <table className="sortable" aria-describedby="campaignNotifications">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  <th>Never</th>
                  <th>Campaigns I am member of</th>
                  <th>All Campaigns</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  
                  <td>{translate("my_account.updates_campaign")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_WORKSPACE_UPDATED"
                        id="rd21"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_WORKSPACE_UPDATED === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_WORKSPACE_UPDATED', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd21"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_WORKSPACE_UPDATED"
                        id="rd22"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_WORKSPACE_UPDATED === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_WORKSPACE_UPDATED', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd22"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_WORKSPACE_UPDATED"
                        id="rd32"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_WORKSPACE_UPDATED === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_WORKSPACE_UPDATED', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd32"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>                 { translate("my_account.cancels_campaign")}
</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_WORKSPACE_CANCELLED"
                        id="rd41"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_WORKSPACE_CANCELLED === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_WORKSPACE_CANCELLED', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd41"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_WORKSPACE_CANCELLED"
                        id="rd51"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_WORKSPACE_CANCELLED === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_WORKSPACE_CANCELLED', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd51"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_WORKSPACE_CANCELLED"
                        id="rd61"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_WORKSPACE_CANCELLED === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_WORKSPACE_CANCELLED', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd61"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>                  {translate("my_account.campaign_closed")}
</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_WORKSPACE_CLOSED"
                        id="rd71"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_WORKSPACE_CLOSED === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_WORKSPACE_CLOSED', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd71"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_WORKSPACE_CLOSED"
                        id="rd81"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_WORKSPACE_CLOSED === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_WORKSPACE_CLOSED', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd81"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_WORKSPACE_CLOSED"
                        id="rd82"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_WORKSPACE_CLOSED === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_WORKSPACE_CLOSED', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd82"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>                  {translate("my_account.adds_campaign")}
</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_WORKSPACE_MEMBER_ADDED"
                        id="rd101"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_WORKSPACE_MEMBER_ADDED === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_WORKSPACE_MEMBER_ADDED', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd101"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_WORKSPACE_MEMBER_ADDED"
                        id="rd111"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_WORKSPACE_MEMBER_ADDED === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_WORKSPACE_MEMBER_ADDED', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd111"
                      ></label>
                    </div>
                  </td>
                  <td>
                  </td>
                </tr>
                <tr>
                  <td>                  {translate("my_account.campaign_completed")}
</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_WORKSPACE_COMPLETED"
                        id="rd131"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_WORKSPACE_COMPLETED === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_WORKSPACE_COMPLETED', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd131"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_WORKSPACE_COMPLETED"
                        id="rd141"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_WORKSPACE_COMPLETED === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_WORKSPACE_COMPLETED', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd141"
                      ></label>
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr>

                  <td>{translate("my_account.requests_acces_campaign")}</td>


                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_WORKSPACE_ACCESS_REQUEST"
                        id="rd131NOTIFY_ON_WORKSPACE_ACCESS_REQUEST"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_WORKSPACE_ACCESS_REQUEST === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_WORKSPACE_ACCESS_REQUEST', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd131NOTIFY_ON_WORKSPACE_ACCESS_REQUEST"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_WORKSPACE_ACCESS_REQUEST"
                        id="rd141NOTIFY_ON_WORKSPACE_ACCESS_REQUEST"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_WORKSPACE_ACCESS_REQUEST === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_WORKSPACE_ACCESS_REQUEST', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd141NOTIFY_ON_WORKSPACE_ACCESS_REQUEST"
                      ></label>
                    </div>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <h5 className="heading-width-border flex-center justify-center" id="quoteNotifications">
          Quote Notifications
        </h5>
        <div className="bid-notification-section show">
          <div className="table-responsive global-table">
            <table className="sortable" aria-describedby="quoteNotifications">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  <th>Never</th>
                  <th>Projects I am member of</th>
                  <th>All projects</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{translate("my_account.quote_submitted")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_BID_SUBMITTED_ALERT"
                        id="rd21NOTIFY_ON_BID_SUBMITTED_ALERT"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_BID_SUBMITTED_ALERT === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_BID_SUBMITTED_ALERT', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd21NOTIFY_ON_BID_SUBMITTED_ALERT"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_BID_SUBMITTED_ALERT"
                        id="rd22NOTIFY_ON_BID_SUBMITTED_ALERT"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_BID_SUBMITTED_ALERT === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_BID_SUBMITTED_ALERT', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd22NOTIFY_ON_BID_SUBMITTED_ALERT"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_BID_SUBMITTED_ALERT"
                        id="rd32NOTIFY_ON_BID_SUBMITTED_ALERT"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_BID_SUBMITTED_ALERT === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_BID_SUBMITTED_ALERT', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd32NOTIFY_ON_BID_SUBMITTED_ALERT"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{translate("my_account.all_quotes_submtted")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_ALL_BIDS_SUBMITTED"
                        id="rd41NOTIFY_ON_ALL_BIDS_SUBMITTED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_ALL_BIDS_SUBMITTED === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_ALL_BIDS_SUBMITTED', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd41NOTIFY_ON_ALL_BIDS_SUBMITTED"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_ALL_BIDS_SUBMITTED"
                        id="rd51NOTIFY_ON_ALL_BIDS_SUBMITTED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_ALL_BIDS_SUBMITTED === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_ALL_BIDS_SUBMITTED', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd51NOTIFY_ON_ALL_BIDS_SUBMITTED"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_ALL_BIDS_SUBMITTED"
                        id="rd61NOTIFY_ON_ALL_BIDS_SUBMITTED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_ALL_BIDS_SUBMITTED === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_ALL_BIDS_SUBMITTED', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd61NOTIFY_ON_ALL_BIDS_SUBMITTED"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>When quotation period has closed for a project</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_BID_CLOSED"
                        id="rd71NOTIFY_ON_BID_CLOSED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_BID_CLOSED === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_BID_CLOSED', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd71NOTIFY_ON_BID_CLOSED"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_BID_CLOSED"
                        id="rd81NOTIFY_ON_BID_CLOSED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_BID_CLOSED === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_BID_CLOSED', 'DEFAULT')}

                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd81NOTIFY_ON_BID_CLOSED"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_BID_CLOSED"
                        id="rd82NOTIFY_ON_BID_CLOSED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_BID_CLOSED === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_BID_CLOSED', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd82NOTIFY_ON_BID_CLOSED"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{translate("my_account.quotation_period_over")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_NO_BIDS_SUBMITTED"
                        id="rd21NOTIFY_ON_NO_BIDS_SUBMITTED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_NO_BIDS_SUBMITTED === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_NO_BIDS_SUBMITTED', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd21NOTIFY_ON_NO_BIDS_SUBMITTED"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_NO_BIDS_SUBMITTED"
                        id="rd22NOTIFY_ON_NO_BIDS_SUBMITTED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_NO_BIDS_SUBMITTED === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_NO_BIDS_SUBMITTED', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd22NOTIFY_ON_NO_BIDS_SUBMITTED"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_NO_BIDS_SUBMITTED"
                        id="rd32NOTIFY_ON_NO_BIDS_SUBMITTED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_NO_BIDS_SUBMITTED === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_NO_BIDS_SUBMITTED', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd32NOTIFY_ON_NO_BIDS_SUBMITTED"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{translate("my_account.quote_reminder")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_BID_SELECTION_REMINDER"
                        id="rd41NOTIFY_ON_BID_SELECTION_REMINDER"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_BID_SELECTION_REMINDER === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_BID_SELECTION_REMINDER', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd41NOTIFY_ON_BID_SELECTION_REMINDER"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_BID_SELECTION_REMINDER"
                        id="rd51NOTIFY_ON_BID_SELECTION_REMINDER"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_BID_SELECTION_REMINDER === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_BID_SELECTION_REMINDER', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd51NOTIFY_ON_BID_SELECTION_REMINDER"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_BID_SELECTION_REMINDER"
                        id="rd61NOTIFY_ON_BID_SELECTION_REMINDER"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_BID_SELECTION_REMINDER === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_BID_SELECTION_REMINDER', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd61NOTIFY_ON_BID_SELECTION_REMINDER"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{translate("my_account.date_expired")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_BID_SELECTION_EXPIRATION"
                        id="rd71NOTIFY_ON_BID_SELECTION_EXPIRATION"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_BID_SELECTION_EXPIRATION === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_BID_SELECTION_EXPIRATION', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd71NOTIFY_ON_BID_SELECTION_EXPIRATION"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_BID_SELECTION_EXPIRATION"
                        id="rd81NOTIFY_ON_BID_SELECTION_EXPIRATION"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_BID_SELECTION_EXPIRATION === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_BID_SELECTION_EXPIRATION', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd81NOTIFY_ON_BID_SELECTION_EXPIRATION"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_BID_SELECTION_EXPIRATION"
                        id="rd82NOTIFY_ON_BID_SELECTION_EXPIRATION"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_BID_SELECTION_EXPIRATION === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_BID_SELECTION_EXPIRATION', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd82NOTIFY_ON_BID_SELECTION_EXPIRATION"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{translate("my_account.vendors_rejects")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_CHANGE_ORDER_SUBMIT_OR_REJECT_BID"
                        id="rd71NOTIFY_ON_CHANGE_ORDER_SUBMIT_OR_REJECT_BID"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_CHANGE_ORDER_SUBMIT_OR_REJECT_BID === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_CHANGE_ORDER_SUBMIT_OR_REJECT_BID', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd71NOTIFY_ON_CHANGE_ORDER_SUBMIT_OR_REJECT_BID"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_CHANGE_ORDER_SUBMIT_OR_REJECT_BID"
                        id="rd81NOTIFY_ON_CHANGE_ORDER_SUBMIT_OR_REJECT_BID"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_CHANGE_ORDER_SUBMIT_OR_REJECT_BID === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_CHANGE_ORDER_SUBMIT_OR_REJECT_BID', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd81NOTIFY_ON_CHANGE_ORDER_SUBMIT_OR_REJECT_BID"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_CHANGE_ORDER_SUBMIT_OR_REJECT_BID"
                        id="rd82NOTIFY_ON_CHANGE_ORDER_SUBMIT_OR_REJECT_BID"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_CHANGE_ORDER_SUBMIT_OR_REJECT_BID === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_CHANGE_ORDER_SUBMIT_OR_REJECT_BID', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd82NOTIFY_ON_CHANGE_ORDER_SUBMIT_OR_REJECT_BID"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{translate("my_account.vendors_cancellation_request")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_CANCELLATION_SUBMIT_BID"
                        id="rd71NOTIFY_ON_PROJECT_CANCELLATION_SUBMIT_BID"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_CANCELLATION_SUBMIT_BID === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_CANCELLATION_SUBMIT_BID', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd71NOTIFY_ON_PROJECT_CANCELLATION_SUBMIT_BID"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_CANCELLATION_SUBMIT_BID"
                        id="rd81NOTIFY_ON_PROJECT_CANCELLATION_SUBMIT_BID"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_CANCELLATION_SUBMIT_BID === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_CANCELLATION_SUBMIT_BID', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd81NOTIFY_ON_PROJECT_CANCELLATION_SUBMIT_BID"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_PROJECT_CANCELLATION_SUBMIT_BID"
                        id="rd82NOTIFY_ON_PROJECT_CANCELLATION_SUBMIT_BID"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_PROJECT_CANCELLATION_SUBMIT_BID === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_PROJECT_CANCELLATION_SUBMIT_BID', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd82NOTIFY_ON_PROJECT_CANCELLATION_SUBMIT_BID"
                      ></label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <h5 className="heading-width-border flex-center justify-center" id="translationNotifications">
          Translation Notifications
        </h5>
        <div className="translation-notification-section show">
          <div className="table-responsive global-table">
            <table className="sortable" aria-describedby="translationNotifications">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  <th>Never</th>
                  <th>Projects I am member of</th>
                  <th>All projects</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{translate("my_account.work_delivered_project")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_LANGUAGE_DELIVERED"
                        id="rd21NOTIFY_ON_LANGUAGE_DELIVERED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_LANGUAGE_DELIVERED === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_LANGUAGE_DELIVERED', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd21NOTIFY_ON_LANGUAGE_DELIVERED"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_LANGUAGE_DELIVERED"
                        id="rd22NOTIFY_ON_LANGUAGE_DELIVERED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_LANGUAGE_DELIVERED === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_LANGUAGE_DELIVERED', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd22NOTIFY_ON_LANGUAGE_DELIVERED"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_LANGUAGE_DELIVERED"
                        id="rd32NOTIFY_ON_LANGUAGE_DELIVERED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_LANGUAGE_DELIVERED === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_LANGUAGE_DELIVERED', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd32NOTIFY_ON_LANGUAGE_DELIVERED"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>                  {translate("my_account.delivered_all_languages")}
</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_ALL_LANGUAGES_DELIVERED"
                        id="rd41NOTIFY_ON_ALL_LANGUAGES_DELIVERED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_ALL_LANGUAGES_DELIVERED === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_ALL_LANGUAGES_DELIVERED', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd41NOTIFY_ON_ALL_LANGUAGES_DELIVERED"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_ALL_LANGUAGES_DELIVERED"
                        id="rd51NOTIFY_ON_ALL_LANGUAGES_DELIVERED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_ALL_LANGUAGES_DELIVERED === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_ALL_LANGUAGES_DELIVERED', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd51NOTIFY_ON_ALL_LANGUAGES_DELIVERED"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_ALL_LANGUAGES_DELIVERED"
                        id="rd61NOTIFY_ON_ALL_LANGUAGES_DELIVERED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_ALL_LANGUAGES_DELIVERED === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_ALL_LANGUAGES_DELIVERED', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd61NOTIFY_ON_ALL_LANGUAGES_DELIVERED"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                 
                  <td> {translate("my_account.translations_approved")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_ALL_LANGUAGES_APPROVED"
                        id="rd71NOTIFY_ON_ALL_LANGUAGES_APPROVED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_ALL_LANGUAGES_APPROVED === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_ALL_LANGUAGES_APPROVED', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd71NOTIFY_ON_ALL_LANGUAGES_APPROVED"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_ALL_LANGUAGES_APPROVED"
                        id="rd81NOTIFY_ON_ALL_LANGUAGES_APPROVED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_ALL_LANGUAGES_APPROVED === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_ALL_LANGUAGES_APPROVED', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd81NOTIFY_ON_ALL_LANGUAGES_APPROVED"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_ALL_LANGUAGES_APPROVED"
                        id="rd82NOTIFY_ON_ALL_LANGUAGES_APPROVED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_ALL_LANGUAGES_APPROVED === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_ALL_LANGUAGES_APPROVED', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd82NOTIFY_ON_ALL_LANGUAGES_APPROVED"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>                  {translate("my_account.single_language_receive")}
</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_SINGLE_LANGUAGE_FINAL_APPROVAL"
                        id="rd21NOTIFY_ON_SINGLE_LANGUAGE_FINAL_APPROVAL"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_SINGLE_LANGUAGE_FINAL_APPROVAL === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_SINGLE_LANGUAGE_FINAL_APPROVAL', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd21NOTIFY_ON_SINGLE_LANGUAGE_FINAL_APPROVAL"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_SINGLE_LANGUAGE_FINAL_APPROVAL"
                        id="rd22NOTIFY_ON_SINGLE_LANGUAGE_FINAL_APPROVAL"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_SINGLE_LANGUAGE_FINAL_APPROVAL === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_SINGLE_LANGUAGE_FINAL_APPROVAL', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd22NOTIFY_ON_SINGLE_LANGUAGE_FINAL_APPROVAL"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_SINGLE_LANGUAGE_FINAL_APPROVAL"
                        id="rd32NOTIFY_ON_SINGLE_LANGUAGE_FINAL_APPROVAL"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_SINGLE_LANGUAGE_FINAL_APPROVAL === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_SINGLE_LANGUAGE_FINAL_APPROVAL', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd32NOTIFY_ON_SINGLE_LANGUAGE_FINAL_APPROVAL"
                      ></label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <h5 className="heading-width-border flex-center justify-center" id="discussionNotifications">
          Discussion Notifications
        </h5>
        <div className="Discussion-notification-section show">
          <div className="table-responsive global-table">
            <table className="sortable" aria-describedby="discussionNotifications">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  <th>Never</th>
                  <th>Discussions I am following</th>
                  <th>All projects</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{translate("my_account.vendor_starts_discussion")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_VENDOR_START_MESSAGE"
                        id="rd21NOTIFY_ON_VENDOR_START_MESSAGE"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_VENDOR_START_MESSAGE === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_VENDOR_START_MESSAGE', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd21NOTIFY_ON_VENDOR_START_MESSAGE"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_VENDOR_START_MESSAGE"
                        id="rd22NOTIFY_ON_VENDOR_START_MESSAGE"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_VENDOR_START_MESSAGE === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_VENDOR_START_MESSAGE', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd22NOTIFY_ON_VENDOR_START_MESSAGE"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_VENDOR_START_MESSAGE"
                        id="rd32NOTIFY_ON_VENDOR_START_MESSAGE"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_VENDOR_START_MESSAGE === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_VENDOR_START_MESSAGE', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd32NOTIFY_ON_VENDOR_START_MESSAGE"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{translate("my_account.vendor_responds")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_VENDOR_RESPOND_MESSAGE"
                        id="rd41NOTIFY_ON_VENDOR_RESPOND_MESSAGE"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_VENDOR_RESPOND_MESSAGE === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_VENDOR_RESPOND_MESSAGE', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd41NOTIFY_ON_VENDOR_RESPOND_MESSAGE"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_VENDOR_RESPOND_MESSAGE"
                        id="rd51NOTIFY_ON_VENDOR_RESPOND_MESSAGE"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_VENDOR_RESPOND_MESSAGE === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_VENDOR_RESPOND_MESSAGE', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd51NOTIFY_ON_VENDOR_RESPOND_MESSAGE"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_VENDOR_RESPOND_MESSAGE"
                        id="rd61NOTIFY_ON_VENDOR_RESPOND_MESSAGE"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_VENDOR_RESPOND_MESSAGE === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_VENDOR_RESPOND_MESSAGE', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd61NOTIFY_ON_VENDOR_RESPOND_MESSAGE"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{translate("my_account.someone_creates_discussion")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_CUSTOMER_MESSAGE_PROJECT_FOLLOWER"
                        id="rd71NOTIFY_ON_CUSTOMER_MESSAGE_PROJECT_FOLLOWER"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_CUSTOMER_MESSAGE_PROJECT_FOLLOWER === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_CUSTOMER_MESSAGE_PROJECT_FOLLOWER', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd71NOTIFY_ON_CUSTOMER_MESSAGE_PROJECT_FOLLOWER"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_CUSTOMER_MESSAGE_PROJECT_FOLLOWER"
                        id="rd81NOTIFY_ON_CUSTOMER_MESSAGE_PROJECT_FOLLOWER"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_CUSTOMER_MESSAGE_PROJECT_FOLLOWER === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_CUSTOMER_MESSAGE_PROJECT_FOLLOWER', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd81NOTIFY_ON_CUSTOMER_MESSAGE_PROJECT_FOLLOWER"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_CUSTOMER_MESSAGE_PROJECT_FOLLOWER"
                        id="rd82NOTIFY_ON_CUSTOMER_MESSAGE_PROJECT_FOLLOWER"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_CUSTOMER_MESSAGE_PROJECT_FOLLOWER === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_CUSTOMER_MESSAGE_PROJECT_FOLLOWER', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd82NOTIFY_ON_CUSTOMER_MESSAGE_PROJECT_FOLLOWER"
                      ></label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <h5 className="heading-width-border flex-center justify-center" id="taskNotifications">
          Task Notifications
        </h5>
        <div className="bid-notification-section show">
          <div className="table-responsive global-table">
            <table className="sortable" aria-describedby="taskNotifications">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  <th>Never</th>
                  <th>Tasks I am following</th>
                  <th>All tasks</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>                {translate("my_account.posts_comment")}
</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_TASK_COMMENT_CREATED"
                        id="rd21NOTIFY_ON_TASK_COMMENT_CREATED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_TASK_COMMENT_CREATED === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_TASK_COMMENT_CREATED', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd21NOTIFY_ON_TASK_COMMENT_CREATED"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_TASK_COMMENT_CREATED"
                        id="rd22NOTIFY_ON_TASK_COMMENT_CREATED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_TASK_COMMENT_CREATED === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_TASK_COMMENT_CREATED', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd22NOTIFY_ON_TASK_COMMENT_CREATED"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_TASK_COMMENT_CREATED"
                        id="rd32NOTIFY_ON_TASK_COMMENT_CREATED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_TASK_COMMENT_CREATED === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_TASK_COMMENT_CREATED', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd32NOTIFY_ON_TASK_COMMENT_CREATED"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{translate("my_account.updates_status")}</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_TASK_STATUS_UPDATED"
                        id="rd41NOTIFY_ON_TASK_STATUS_UPDATED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_TASK_STATUS_UPDATED === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_TASK_STATUS_UPDATED', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd41NOTIFY_ON_TASK_STATUS_UPDATED"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_TASK_STATUS_UPDATED"
                        id="rd51NOTIFY_ON_TASK_STATUS_UPDATED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_TASK_STATUS_UPDATED === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_TASK_STATUS_UPDATED', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd51NOTIFY_ON_TASK_STATUS_UPDATED"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_TASK_STATUS_UPDATED"
                        id="rd61NOTIFY_ON_TASK_STATUS_UPDATED"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_TASK_STATUS_UPDATED === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_TASK_STATUS_UPDATED', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd61NOTIFY_ON_TASK_STATUS_UPDATED"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Reminder that the task deadline is approaching</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_TASK_DUE_DATE_REMINDER"
                        id="rd71NOTIFY_ON_TASK_DUE_DATE_REMINDER"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_TASK_DUE_DATE_REMINDER === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_TASK_DUE_DATE_REMINDER', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd71NOTIFY_ON_TASK_DUE_DATE_REMINDER"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_TASK_DUE_DATE_REMINDER"
                        id="rd81NOTIFY_ON_TASK_DUE_DATE_REMINDER"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_TASK_DUE_DATE_REMINDER === 'DEFAULT'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_TASK_DUE_DATE_REMINDER', 'DEFAULT')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd81NOTIFY_ON_TASK_DUE_DATE_REMINDER"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_TASK_DUE_DATE_REMINDER"
                        id="rd82NOTIFY_ON_TASK_DUE_DATE_REMINDER"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_TASK_DUE_DATE_REMINDER === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_TASK_DUE_DATE_REMINDER', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd82NOTIFY_ON_TASK_DUE_DATE_REMINDER"
                      ></label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>                 { translate("my_account.some_follower")}
</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_TASK_ADD_FOLLOWER"
                        id="rd21NOTIFY_ON_TASK_ADD_FOLLOWER"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_TASK_ADD_FOLLOWER === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_TASK_ADD_FOLLOWER', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd21NOTIFY_ON_TASK_ADD_FOLLOWER"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_TASK_ADD_FOLLOWER"
                        id="rd32NOTIFY_ON_TASK_ADD_FOLLOWER"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_TASK_ADD_FOLLOWER === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_TASK_ADD_FOLLOWER', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd32NOTIFY_ON_TASK_ADD_FOLLOWER"
                      ></label>
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>                  {translate("my_account.workflow_task")}
</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_TASK_ASSIGNMENT"
                        id="rd21NOTIFY_ON_TASK_ASSIGNMENT"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_TASK_ASSIGNMENT === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_TASK_ASSIGNMENT', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd21NOTIFY_ON_TASK_ASSIGNMENT"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_ON_TASK_ASSIGNMENT"
                        id="rd32NOTIFY_ON_TASK_ASSIGNMENT"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_ON_TASK_ASSIGNMENT === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_ON_TASK_ASSIGNMENT', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd32NOTIFY_ON_TASK_ASSIGNMENT"
                      ></label>
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>                  {translate("my_account.sends_daily_digests")}
</td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_WITH_TASK_DIGEST"
                        id="rd21NOTIFY_WITH_TASK_DIGEST"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_WITH_TASK_DIGEST === 'NONE'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_WITH_TASK_DIGEST', 'NONE')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd21NOTIFY_WITH_TASK_DIGEST"
                      ></label>
                    </div>
                  </td>
                  <td>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="radioNOTIFY_WITH_TASK_DIGEST"
                        id="rd32NOTIFY_WITH_TASK_DIGEST"
                        disabled={disabled}
                        checked={notificatonPreference?.NOTIFY_WITH_TASK_DIGEST === 'ALL'}
                        onChange={(e) => updateNotificationPreference(e.target, 'NOTIFY_WITH_TASK_DIGEST', 'ALL')}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="rd32NOTIFY_WITH_TASK_DIGEST"
                      ></label>
                    </div>
                  </td>
                  <td></td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
      {!disabled ?
        <div className="stricy-btn flex flex-center no-rightlist justify-end">
          <div className="left flex">
            <div>
              <button className="btn-default" onClick={onCancel}>Cancel</button>
            </div>
            <div>
              <button className="btn-default" onClick={updateNotification}>Save Changes</button>
            </div>
          </div>
        </div> : null
      }

    </>
  );
}
